export default __webpack_public_path__ + "static/media/button_point-on.97ee7920.svg";